function getHtml(message, namespace) {
  let className = '';
  let icon = '';

  switch (namespace) {
    case 'info':
      className = 'alert-info';
      icon = 'info-circle';
      break;
    case 'warning':
      className = 'alert-warning';
      icon = 'exclamation-circle';
      break;
    case 'error':
      className = 'alert-danger';
      icon = 'exclamation-circle';
      break;
    default:
      className = 'alert-success';
      icon = 'check-circle';
  }

  return `
    <div class="alert ${className} alert-dismissible" role="alert">
        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
        <i class="fa fa-${icon}"></i>
        ${message}
    </div>
  `;
}

function showFlashMessage(message, namespace) {
  const flashMessage = getHtml(message, namespace);
  $('#flash-messages').append(flashMessage);
}

module.exports = {
  showFlashMessage
};
